export enum UserRole {
  Renter = 'renter',
  Owner = 'owner',
}

export enum UserStatus {
  PendingVerification = 'pending_verification',
  PendingApproval = 'pending_approval',
  Active = 'active',
  Rejected = 'rejected',
  Suspended = 'suspended',
}

export enum Currency {
  USD = 'USD',
  EUR = 'EUR',
  NZD = 'NZD',
  CAD = 'CAD',
}

export enum Language {
  EN = 'en',
  FR = 'fr',
}
